import cn from "classnames";
import Pagination from "components/shared/reactTable/pagination";
import { splitKeyFromProps } from "helpers/reactTableProps";
import React from "react";
import { useFilters, useFlexLayout, usePagination, useResizeColumns, useSortBy, useTable } from "react-table";

const Table = (props) => {
    const instance = useTable(
        { ...props, initialState: { ...props.initialState, pageIndex: 0, pageSize: 30 } },
        useResizeColumns,
        useFlexLayout,
        useFilters,
        useSortBy,
        usePagination,
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageCount,
        page,
        loadingText,
        loadingComponent,
        loading,
        state: { pageIndex, pageSize },
        gotoPage,
        setPageSize,
    } = instance;
    const { pageSizeOptions } = props;
    const paginationProps = {
        page: pageIndex,
        pages: pageCount,
        pageSize,
        onPageChange: gotoPage,
        onPageSizeChange: setPageSize,
        pageSizeOptions,
    };
    const iconClass = (column, direction, baseClass) =>
        cn(baseClass, {
            "r-table__sort-icon--active":
                column.isSorted && (column.isSortedDesc ? direction === "desc" : direction === "asc"),
            "r-table__sort-icon--disabled":
                column.isSorted && (column.isSortedDesc ? direction === "asc" : direction === "desc"),
        });
    return (
        <>
            <div {...getTableProps()} className="r-table table-sm">
                <div className="r-table__thead">
                    {headerGroups.map((headerGroup, i) => {
                        const { key: headerGroupKey, props: headerGroupProps } = splitKeyFromProps(
                            headerGroup.getHeaderGroupProps(),
                        );
                        return (
                            <div key={headerGroupKey ?? i} {...headerGroupProps} className="tr">
                                {headerGroup.headers.map((column, i) => {
                                    const { key: headerKey, props: headerProps } = splitKeyFromProps(
                                        column.getHeaderProps(column.getSortByToggleProps()),
                                    );
                                    return (
                                        <div key={headerKey ?? i} {...headerProps} title="" className="th">
                                            <div
                                                className={`r-table__column-title ${column.canSort ? "r-table__column-title--sortable" : ""}`}
                                            >
                                                {column.render("Header")}
                                                {column.canSort && (
                                                    <span className="r-table__sort-icon">
                                                        <i
                                                            className={iconClass(
                                                                column,
                                                                "desc",
                                                                "r-table__sort-icon--down",
                                                            )}
                                                        />

                                                        <i
                                                            className={iconClass(
                                                                column,
                                                                "asc",
                                                                "r-table__sort-icon--up",
                                                            )}
                                                        />
                                                    </span>
                                                )}
                                            </div>
                                            {column.filterable && (
                                                <div
                                                    className="r-table__column-filter"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    {column.render("Filter")}
                                                </div>
                                            )}
                                            <div
                                                {...column.getResizerProps()}
                                                className={`r-table__resizer ${column.isResizing ? "isResizing" : ""}`}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
                <div className="r-table__tbody" {...getTableBodyProps()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const { key: rowKey, props: rowProps } = splitKeyFromProps(row.getRowProps());
                        return (
                            <div key={rowKey ?? rowIndex} {...rowProps} className="tr">
                                {row.cells.map((cell, i) => {
                                    const { key: cellKey, props: cellProps } = splitKeyFromProps(cell.getCellProps());
                                    return (
                                        <div key={cellKey ?? i} {...cellProps} className="td">
                                            {cell.column.id === "row_number"
                                                ? pageIndex * pageSize + rowIndex + 1
                                                : cell.render("Cell")}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                    <div className={cn("rt-loading", { "rt-active": loading })}>
                        <div className="rt-loading-inner">{loadingText || loadingComponent}</div>
                    </div>
                    {page.length === 0 && <div className="rt-noData">Нет данных для отображения</div>}
                </div>
            </div>
            <div className="r-table__tfoot">
                <Pagination isNotExportable {...paginationProps} />
            </div>
        </>
    );
};

export default Table;
